import React from 'react'
import { FormGroupCardProps } from './types'

/**
 * FormGroupCard - Consistent card component for wizard form groups
 * 
 * Features:
 * - Matches design system styling from product-listing-crud-with-sidebar.html
 * - Proper header with title and subtitle
 * - Consistent spacing and borders
 * - Responsive design with mobile/desktop support
 * - Dark mode preparation
 */
function FormGroupCard({
  title,
  subtitle,
  children,
  className = ''
}: FormGroupCardProps): JSX.Element {
  return (
    <div className={`tw-bg-white dark:tw-bg-[#1C252E] tw-rounded-xl tw-border tw-border-gray-200 dark:tw-border-[#233648] tw-p-4 md:tw-p-6 tw-shadow-sm ${className}`}>
      {/* Header Section */}
      <div className="tw-mb-6 tw-border-b tw-border-gray-200 dark:tw-border-[#364152] tw-pb-4">
        <h3 className="tw-text-lg tw-font-bold tw-text-gray-900 dark:tw-text-white">
          {title}
        </h3>
        <p className="tw-text-sm tw-text-gray-500 dark:tw-text-gray-400">
          {subtitle}
        </p>
      </div>

      {/* Content Section */}
      <div className="tw-space-y-4">
        {children}
      </div>
    </div>
  )
}

export default FormGroupCard